

let iframeSrc;
let iframeElement;
let overlayEl;
let closeBtnEl;
const customer = "MIKEMYSTICBARRELSCOM";

const waitForMazingFunction = new Promise((resolve) => {
    const t = setInterval(() => {
        if (typeof window.mazingProjectAvailable === "function") {
            clearInterval(t);
            resolve();
        }
    }, 50);
});

const waitForElement = (sel, timeout = 55000) => new Promise((resolve) => {
    let elapsed = 0;
    const t = setInterval(() => {
        const el = document.querySelector(sel);
        if (el) { clearInterval(t); resolve(el); }
        else if ((elapsed += 50) >= timeout) { clearInterval(t); resolve(); }
    }, 50);
});

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/").filter(Boolean);
    const product = parts[parts.length - 1].split('?')[0];
    return product.toLowerCase();
};

const createOverlayInGallery = (galleryContainer) => {
    const style = window.getComputedStyle(galleryContainer);
    if (style.position === 'static') galleryContainer.style.position = 'relative';

    overlayEl = document.createElement('div');
    overlayEl.setAttribute('aria-hidden', 'true');
    Object.assign(overlayEl.style, {
        position: 'absolute', inset: '0', display: 'none', zIndex: '10', pointerEvents: 'auto'
    });

    const inner = document.createElement('div');
    Object.assign(inner.style, {
        position: 'absolute', inset: '0', background: '#fff', borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0,0,0,.18)', overflow: 'hidden'
    });

    closeBtnEl = document.createElement('button');
    closeBtnEl.type = 'button';
    closeBtnEl.setAttribute('aria-label', 'Close 3D viewer');
    closeBtnEl.innerHTML = '&times;';
    Object.assign(closeBtnEl.style, {
        position: 'absolute', top: '10px', right: '10px', width: '36px', height: '36px',
        lineHeight: '32px', fontSize: '24px', fontWeight: '700', borderRadius: '9999px',
        background: 'rgba(255,255,255,0.92)', border: '1px solid rgba(0,0,0,.12)',
        cursor: 'pointer', zIndex: '2'
    });

    iframeElement = document.createElement('iframe');
    Object.assign(iframeElement.style, { position: 'absolute', inset: '0', width: '100%', height: '100%', border: 'none' });
    iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";
    iframeElement.loading = 'eager';

    inner.appendChild(closeBtnEl);
    inner.appendChild(iframeElement);
    overlayEl.appendChild(inner);
    galleryContainer.appendChild(overlayEl);
};

const showOverlay = () => {
    if (!overlayEl) return;
    if (!iframeElement.src && iframeSrc) iframeElement.src = iframeSrc;
    overlayEl.style.display = 'block';
    overlayEl.setAttribute('aria-hidden', 'false');
};
const hideOverlay = () => {
    if (!overlayEl) return;
    overlayEl.style.display = 'none';
    overlayEl.setAttribute('aria-hidden', 'true');
};

const initializeMazingButton = async () => {
    await mazing({
        customerName: customer,
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container { z-index:0; display:flex; margin:24px 0 0; justify-content:center; }
                .mazing-threed-btn, .mazing-ar-btn { border:none !important; display:flex; gap:10px; padding:10px 24px; border-radius:5px; margin-right:0px; width:100%; justify-content:center !important; }
                .mazing-threed-btn-text, .mazing-ar-btn-text { font-weight:600; color:black; }
                .mazing-ar-btn, .mazing-threed-btn { display:none }
                .mazing-threed-btn-icon { filter: brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%); }
            `,
            placementSelector: '.pwzrjss1',
            threedBtn: { enabled: true, icon: true, customText: "View in 3D" },
            arBtn: { enabled: false, icon: false, customText: "" }
        },
        getSKU: getCurrentSKU
    });

    const ensureButtonAtBottom = () => {
        const host = document.querySelector('.pwzrjss1');
        const btnWrap = host?.querySelector('.mazing-button-container');
        if (host && btnWrap && host.firstElementChild !== btnWrap) {
            host.insertBefore(btnWrap, host.firstElementChild);
        }
    };


    const hookMazingButton = () => {
        const btn = document.querySelector('.mazing-threed-btn');
        if (!btn || btn.__mazingHooked) return;

        const open = (e) => { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); showOverlay(); };
        btn.addEventListener('click', open, true);
        btn.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') open(e); }, true);

        btn.__mazingHooked = true;
        ensureButtonAtBottom();
    };

    hookMazingButton();
    new MutationObserver(() => {
        hookMazingButton();
        ensureButtonAtBottom();
    }).observe(document.querySelector('.pwzrjss1') || document.body, { childList: true, subtree: true });
};

const setupChoiceListeners = () => {
    document.querySelectorAll('.choices').forEach((box) => {
        if (box.__mazingHooked) return;
        box.__mazingHooked = true;

        box.addEventListener('click', (e) => {
            let input = e.target.closest('input[type="radio"]');
            if (!input) {
                const lbl = e.target.closest('label[for]');
                if (lbl && lbl.htmlFor) input = document.getElementById(lbl.htmlFor);
            }
            if (!input || input.type !== 'radio') return;

            const slugify = (s) =>
                (s || "")
                    .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
                    .replace(/[“”"’‘']/g, "")
                    .toLowerCase()
                    .replace(/&/g, " and ")
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/^-+|-+$/g, "")
                    .replace(/-+/g, "-");

            const valueRaw = input.value;
            const trigger = slugify(valueRaw);
            showOverlay();

            const payload = { type: 'SWITCH_VARIANT', value: { trigger: trigger } };
            if (!iframeElement?.src && iframeSrc) {
                iframeElement.src = iframeSrc;
                iframeElement.addEventListener('load', () => {
                    iframeElement.contentWindow?.postMessage(payload, '*');
                }, { once: true });
            } else {
                iframeElement?.contentWindow?.postMessage(payload, '*');
            }
            console.log('MAZING: Sent SWITCH_VARIANT →', trigger);
        });
    });
};

/* ---- Init ---- */
(async () => {
    try {
        await waitForMazingFunction;

        const galleryContainer = await waitForElement('#pwzrswiper-container-wrapper');
        if (!galleryContainer) return;

        iframeSrc = await mazingProjectAvailable({ customerName: customer, getSKU: getCurrentSKU });
        if (!iframeSrc) { console.log('iframeSrc not found, aborting.'); return; }

        createOverlayInGallery(galleryContainer);
        closeBtnEl.addEventListener('click', hideOverlay);

        await initializeMazingButton();
        setupChoiceListeners();

        const mazingBtn = document.querySelector('.mazing-threed-btn');
        setTimeout(() => {
            if (mazingBtn) {
                mazingBtn.style.display = 'flex';
            }
        }, 500)

        console.log('Mazing overlay ready.');
    } catch (e) {
        console.error('Initialization failed:', e);
    }
})();
